import t, { useState as u } from "react";
import n from "./index185.mjs";
import { GiftCardTile as f } from "./index186.mjs";
import b from "classnames";
import g from "./index171.mjs";
import p from "./index187.mjs";
import { useSetAtom as c } from "jotai";
import { setCurrentStepAtom as _ } from "./index25.mjs";
import { selectedGiftCardAtom as C } from "./index64.mjs";
const i = ({
  onClick: e,
  disabled: l,
  children: r,
  ariaLabel: o
}) => /* @__PURE__ */ t.createElement(
  "button",
  {
    type: "button",
    className: b(n.scroller, {
      [n["scroller-disabled"]]: l
    }),
    onClick: e,
    disabled: l,
    "data-testid": "scroller",
    "aria-label": o
  },
  r
), A = ({
  giftCards: e,
  currency: l
}) => {
  const [r, o] = u(0), s = c(C), m = c(_), d = () => {
    s(e[r]), m(1);
  };
  return /* @__PURE__ */ t.createElement(
    "section",
    {
      className: n["gift-card-carousel"],
      "data-testid": "gift-card-carousel",
      "aria-label": I18n.t("booking_engine.accessibility.carousel_gift_cards")
    },
    e.length > 1 ? /* @__PURE__ */ t.createElement(
      i,
      {
        onClick: () => o((a) => a - 1),
        disabled: r === 0,
        ariaLabel: I18n.t(
          "booking_engine.accessibility.carousel_previous_gift_card"
        )
      },
      /* @__PURE__ */ t.createElement(g, null)
    ) : null,
    /* @__PURE__ */ t.createElement(
      f,
      {
        giftCard: e[r],
        currency: l,
        onSelect: d
      }
    ),
    e.length > 1 ? /* @__PURE__ */ t.createElement(
      i,
      {
        onClick: () => o((a) => a + 1),
        disabled: r === e.length - 1,
        ariaLabel: I18n.t(
          "booking_engine.accessibility.carousel_next_gift_card"
        )
      },
      /* @__PURE__ */ t.createElement(p, null)
    ) : null
  );
};
export {
  A as GiftCardCarousel
};
